<!--
    校区管理-授权统计
    作用：展示校区授权管理
    实现：展示列表数据、导出搜索数据、查看授权账号数详情
    组件：AppList、AppSearch
    版本号: 3.0
-->
<template>
  <div>
    <AppList
      ref="list"
      :list.sync="list"
      api="/api/service/operate/exercise/operate/auth_numbers"
      title="">
      <AppSearch
        slot="search"
        :search-arr="searchArrLive"/>
      <template slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="item in columnsLive"
            :key="item.id"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :prop="item.prop"
            :formatter="item.formatter"
          />
          <el-table-column
            label="授权状态"
            width="100px"
            align="center"
          >
            <template slot-scope="{row}">
              <span :class="authClass[row.auth_status]">{{ authType[row.auth_status] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in columnsLive2"
            :key="item.id"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :prop="item.prop"
            :formatter="item.formatter"
          />
          <el-table-column
            label="操作"
            width="100px"
            class="orgin-btn"
          >
            <template
              slot-scope="{row}">
              <el-button
                v-if="row.auth_status===1"
                size="small"
                @click="cancelAuth(row)"
              >取消授权</el-button>
              <span
                v-else
                style="width:100%;float:left;text-align:center">已取消</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
    <users-info-dialog
      v-if="showUserInfo"
      :visible.sync="showUserInfo"
      :cur-row="curRow"/>
  </div>
</template>
<script>

export default {
  name: 'AuthorityStatistics',
  components: {
  },
  data() {
    return {
      showUserInfo: false,
      curRow: {},
      list: {},
      apiUrl: '',
      authType: {
        0: '未授权',
        1: '已授权',
        2: '取消授权',
      },
      authClass: {
        0: 'text-info',
        1: 'text-success',
        2: 'text-danger',
      },
      columnsLive: [{
        prop: 'to_client.review_used.name',
        label: '被授权校区名称',
        minWidth: '130px',
      },
      {
        prop: 'to_client.school_code',
        label: '被授权校区代码',
        minWidth: '100px',
      },
      {
        prop: 'to_client.review_used.user_mobile',
        label: '校长手机号',
        width: '120px',
      },
      ],
      columnsLive2: [
        {
          prop: 'auth_number',
          label: '授权条数',
        },
        {
          prop: 'created_at',
          width: '100px',
          label: '授权时间',
        },
        {
          prop: 'deleted_at',
          width: '100px',
          label: '取消时间',
        },
        {
          prop: 'user.name',
          label: '操作人名称',
          minWidth: '100px',
        },
        {
          prop: 'user.mobile',
          label: '操作人账号',
          minWidth: '130px',
        },
      ],
      downloadLoading: false,
    };
  },
  computed: {
    searchArrLive() {
      return [
        {
          componentType: 'AppSearchDate',
          searchType: 'created_at',
        },
        {
          selectValue: [
            { value: 0, name: '未授权' },
            { value: 1, name: '已授权' },
            { value: 2, name: '取消授权' },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'auth_status',
          placeholder: '授权状态',
        },
        {
          componentType: 'AppSearchColumn',
          searchType: 'search_school_name',
          placeholder: '校区名称' },
      ];
    },
  },
  created() {
    this.apiUrl = 'api/service/operate/exercise/operate/auth_numbers';
  },
  methods: {
    cancelAuth(row) {
      console.log('rowrowrowrowrowrowrowrowrowrow', row);
      this.$confirm('该操作将取消授权，是否继续?', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            this.$http
              .delete(`/api/service/operate/exercise/operate/auth_numbers/${row.id}`)
              .then(() => {
                done();
                instance.confirmButtonLoading = false;
              })
              .catch((err) => {
                this.$message.error(err.message);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      })
        .then(() => {
          this.$message.success('授权取消成功!');
        });
    },
    authInfo(row) {
      if (row.auth_status) {
        this.curRow = Object.assign(row);
        this.showUserInfo = true;
      }
    },
    // 账号数
    filterUserCount(row) {
      const newArr = [];
      row.users.forEach((item) => {
        if (item.auth_status === 1) {
          newArr.push(item);
        }
      });
      return newArr;
    },
    downloadExcel() {
      this.downloadLoading = true;
      const query = Object.keys(this.$route.query)
        .map(key => `${key}=${this.$route.query[key]}`)
        .join('&');
      this.$http.get(`/api/packet/packet-record-list-export?${query}`, { responseType: 'blob' }).then((res) => {
        this.$setting.saveAs(res, '授权统计');
      }).finally(() => {
        this.downloadLoading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/CampusManagement/list/authorize/index.vue